import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { dispatch, connect } from "../recontext/store";
import ButtonLogin from "./ButtonLogin";

const styles = theme => ({});

class LoginDialog extends React.PureComponent {
  handleClose() {
    dispatch("HIDE_LOGIN_DIALOG");
  }

  render() {
    const { loginDialogVisible } = this.props;

    return (
      <Dialog
        open={loginDialogVisible}
        disableBackdropClick={true}
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Login Reqruired</DialogTitle>
        <DialogContent>
          <Typography variant="subheading">
            Please login with Facebook to continue
          </Typography>
          <ButtonLogin />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Later
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({
  loginDialogVisible: state.loginDialogVisible
});

export default connect(mapStateToProps)(withStyles(styles)(LoginDialog));
